export default {
  appConfig: {    
    baseApiUrl: "/globus/api",
    secondApiUrl: "/newsources/",
  },
  settings: {
    module: "module_sources",
    path: "/main",
  },
  getCommonSources: "/CommonSources",
  getInternalSources: "/sources/",
  postCommonSources: "/CommonSources",
  postInternalSources: "/sources/",
  putInternalSources: "/sources/",
  patchInternalSources: "/sources/",
  deleteInternalSource: "/sources/",
  postFeed: "/feed",
  getDeletedSources: "/feed/GetDeletedSources",
  getDisabledSources: "/feed/GetDisabledSources",
  activateFeeds: "/feed/activateFeeds",
  disableFeeds: "/feed/DisableFeeds",
  changeFeedUrl: "/feed/ChangeFeedUrl",
  removeFeed: "/feed/removeFeed",
  filteredFeeds: "/feed/filteredFeeds",
  getInternalTags: "/tags",
  postInternalTags: "/tags",
  deleteInternalTags: "/tags",
  // Analytics
  getAnalyticsNewsBySource: "/stats/calculate",
  getAnalyticsNewsFlow: "/stats/news_count",
  getAnalyticsSourcesActivity: "/stats/source_statistics",
};